import { render, staticRenderFns } from "./AboutSlider.vue?vue&type=template&id=4febd1c3"
import script from "./AboutSlider.vue?vue&type=script&lang=js"
export * from "./AboutSlider.vue?vue&type=script&lang=js"
import style0 from "./AboutSlider.vue?vue&type=style&index=0&id=4febd1c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports